export function stopScanner(scannerDiv, stopScannerBtn) {
    document.getElementById(scannerDiv).style.display = 'none';
    document.getElementById(stopScannerBtn).style.display = 'none';
    Quagga.stop();
}
